/* eslint-disable max-lines-per-function */
import React from 'react';
export const GalleryTwoColumnsPreview = (): JSX.Element => (
    <svg xmlns="http://www.w3.org/2000/svg" width="287" height="143" viewBox="0 0 287 143">
        <g data-name="Gallery: two columns" transform="translate(-832 -2232)">
            <g fill="#fff" transform="translate(832 2232)">
                <rect width="287" height="143" stroke="none" rx="4" />
                <rect width="286" height="142" x="0.5" y="0.5" fill="none" rx="3.5" />
            </g>
            <g data-name="Group 14406" transform="translate(856.264 2256)">
                <g data-name="Group 8115" transform="translate(-.264)">
                    <g fill="#edf2f7" stroke="#e2e8f0" strokeWidth="1" data-name="Rectangle 6270">
                        <rect width="107" height="95" stroke="none" rx="4" />
                        <rect width="106" height="94" x="0.5" y="0.5" fill="none" rx="3.5" />
                    </g>
                </g>
                <g fill="none" stroke="#cbd5e1" strokeWidth="2" transform="translate(40.236 34.986)">
                    <g data-name="Rectangle 7981">
                        <rect width="26" height="26" stroke="none" rx="5" />
                        <rect width="24" height="24" x="1" y="1" rx="4" />
                    </g>
                    <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M.91 17.636l4.677-5.247 5.572 4.429"
                        data-name="Path 26926"
                    />
                    <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M4.472 24.406l14.983-16.28 5.847 5.479"
                        data-name="Path 26927"
                    />
                    <g strokeLinecap="round" data-name="Ellipse 1907" transform="translate(5.039 4.333)">
                        <ellipse cx="2.305" cy="2.305" stroke="none" rx="2.305" ry="2.305" />
                        <ellipse cx="2.305" cy="2.305" rx="1.305" ry="1.305" />
                    </g>
                </g>
            </g>
            <g data-name="Group 14407" transform="translate(988.264 2256)">
                <g data-name="Group 8115" transform="translate(-.264)">
                    <g fill="#edf2f7" stroke="#e2e8f0" strokeWidth="1" data-name="Rectangle 6270">
                        <rect width="107" height="95" stroke="none" rx="4" />
                        <rect width="106" height="94" x="0.5" y="0.5" fill="none" rx="3.5" />
                    </g>
                </g>
                <g
                    fill="none"
                    stroke="#cbd5e1"
                    strokeWidth="2"
                    data-name="campaign-placeholder"
                    transform="translate(40.236 34.986)"
                >
                    <g data-name="Rectangle 7981">
                        <rect width="26" height="26" stroke="none" rx="5" />
                        <rect width="24" height="24" x="1" y="1" rx="4" />
                    </g>
                    <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M.91 17.636l4.677-5.247 5.572 4.429"
                        data-name="Path 26926"
                    />
                    <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M4.472 24.406l14.983-16.28 5.847 5.479"
                        data-name="Path 26927"
                    />
                    <g strokeLinecap="round" data-name="Ellipse 1907" transform="translate(5.039 4.333)">
                        <ellipse cx="2.305" cy="2.305" stroke="none" rx="2.305" ry="2.305" />
                        <ellipse cx="2.305" cy="2.305" rx="1.305" ry="1.305" />
                    </g>
                </g>
            </g>
        </g>
    </svg>
);
